import {hasBeenFilled} from "./dynamicFormHelper";
import {CoordinatesType} from "../types/shape";

export const SELECT_SHAPE_COLOR = "#3388ff";

export const panMapToCenterCoordinates = (mapRef, center, zoom) => {
  if (center && zoom) {
    // get native Map instance
    const map = mapRef.current.leafletElement;

    // fitBound need lat - long coordinates
    map.flyTo(center, zoom);
  }
};

interface BBoxType {
  minLat: number,
  maxLat: number,
  minLong: number,
  maxLong: number,
}

export const panMapToBBoxBoundsCoordinates = (mapRef, allCoordinates: CoordinatesType[]) => {
  const bbox = extractBBoxByCoordinates(allCoordinates);
  if (!!mapRef && !!bbox) {
    // get native Map instance
    const map = mapRef.current.leafletElement;

    // fitBound need lat - long coordinates
    map.fitBounds([
      [bbox.minLat, bbox.minLong],
      [bbox.minLat, bbox.maxLong],
      [bbox.maxLat, bbox.maxLong],
      [bbox.maxLat, bbox.minLong],
    ]);
  }
};

// long - lat coordinates in input
export const extractBBoxByCoordinates = (
  allCoordinates: CoordinatesType[]
): BBoxType | null => {
  const bbox:any = {};
  allCoordinates
    .forEach((coordinates: CoordinatesType) => {
      const minLong = Math.min(...coordinates.map((coords) => coords[0]));
      const maxLong = Math.max(...coordinates.map((coords) => coords[0]));

      const minLat = Math.min(...coordinates.map((coords) => coords[1]));
      const maxLat = Math.max(...coordinates.map((coords) => coords[1]));

      if (!bbox.minLat || bbox.minLat > minLat) bbox.minLat = minLat;
      if (!bbox.maxLat || bbox.maxLat < maxLat) bbox.maxLat = maxLat;

      if (!bbox.minLong || bbox.minLong > minLong) bbox.minLong = minLong;
      if (!bbox.maxLong || bbox.maxLong < maxLong) bbox.maxLong = maxLong;
    });

  return hasBeenFilled(bbox.minLat) && hasBeenFilled(bbox.minLong) && hasBeenFilled(bbox.maxLat) && hasBeenFilled(bbox.maxLong)
    ? bbox
    : null
};
